import { render, staticRenderFns } from "./ConsultarDocumentos.vue?vue&type=template&id=93174f94&scoped=true"
import script from "./ConsultarDocumentos.vue?vue&type=script&lang=js"
export * from "./ConsultarDocumentos.vue?vue&type=script&lang=js"
import style0 from "./ConsultarDocumentos.vue?vue&type=style&index=0&id=93174f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93174f94",
  null
  
)

export default component.exports